import EmailCompositionContent from 'models/composition/email_composition_content';
import Err from 'models/err';
import Upload from 'models/upload';

export default class StartUpload {
  constructor(context) {
    this.context = context;
  }

  run({ file, contentChannelType, onInsertImage, isInline, language }) {
    let snippetCompositionStore = this.context.stores.snippetComposition;

    let errors = Upload.getValidationErrors({ file });
    if (errors.length) {
      snippetCompositionStore.setErrors(errors);
      return;
    }

    let upload = Upload.create({ file, isInline });
    let largeUploadError = this.constructor.validateSize(upload);
    if (largeUploadError.length) {
      snippetCompositionStore.setErrors(largeUploadError);
      return;
    }

    let snippetComposition = snippetCompositionStore.get();
    let content = snippetComposition.findOrCreateContentByLanguage(language);
    if (!content[contentChannelType]) {
      content.addContentOfType(contentChannelType);
    }
    content[contentChannelType].addAttachment(upload);
    this.context.stores.snippetComposition.clearErrors();
    this.context.stores.snippetComposition.set(snippetComposition);

    this.context.gateways.snippetUpload.fetchUploadAuth(
      snippetComposition.getUploadPath(upload.id),
      upload.fileDescriptor().toJs()
    );

    // inline images
    if (upload.isImage() && onInsertImage) {
      const orgId = this.context.stores.auth.get().getOrgId();
      onInsertImage(orgId, upload);
    }
  }

  static validateSize(upload) {
    if (upload.fileDescriptor().contentLength > EmailCompositionContent.MAX_SINGLE_ATTACHMENT_SIZE_MB * MB) {
      return [
        new Err({
          attr: 'attachments',
          code: Err.Code.TOO_LONG,
          detail: `Attachment ${upload.fileDescriptor().filename} exceeds ${
            EmailCompositionContent.MAX_SINGLE_ATTACHMENT_SIZE_MB
          }MB`,
        }),
      ];
    }
    return [];
  }
}
const MB = 1 << (10 * 2);



// WEBPACK FOOTER //
// ./src/scripts/application/actions/knowledge_base/start_upload.js